import Vue from 'vue';
import VueChartist from 'vue-chartist';

import 'chartist/dist/chartist.min.css';

Vue.use(VueChartist);
